{
    "availabilityZones": [],
    "badges": [],
    "gridUnitPixels": 20,
    "heightUnits": 41,
    "labels": [],
    "lines": [],
    "mapId": "basement",
    "mapName": "Basement",
    "rackSlots": [
        {
            "capacityU": 42,
            "depth": 5,
            "id": "basement-floor-slot-3",
            "purpose": "standard",
            "rotation": 90,
            "slot": 3,
            "type": "standing",
            "width": 7,
            "x": 24.5,
            "y": 18.5
        },
        {
            "capacityU": 42,
            "depth": 5,
            "id": "basement-floor-slot-2",
            "purpose": "standard",
            "rotation": 90,
            "slot": 2,
            "type": "standing",
            "width": 7,
            "x": 30,
            "y": 18.5
        },
        {
            "capacityU": 42,
            "depth": 5,
            "id": "basement-floor-slot-1",
            "purpose": "standard",
            "rotation": 90,
            "slot": 1,
            "type": "standing",
            "width": 7,
            "x": 35.5,
            "y": 18.5
        },
        {
            "capacityU": 42,
            "depth": 5,
            "id": "basement-floor-slot-0",
            "purpose": "standard",
            "rotation": 90,
            "slot": 0,
            "type": "standing",
            "width": 7,
            "x": 41,
            "y": 18.5
        },
        {
            "capacityU": 4,
            "depth": 7,
            "eddSlotU": 4,
            "id": "basement-wall-rack",
            "purpose": "uplink",
            "rotation": 0,
            "type": "wall",
            "width": 3,
            "x": 44.5,
            "y": 29
        }
    ],
    "schema": "uptime-facility-map",
    "version": 2,
    "walls": [
        {
            "id": "garage-north",
            "kind": "exterior",
            "x1": 10,
            "x2": 48,
            "y1": 1,
            "y2": 1
        },
        {
            "id": "garage-east",
            "kind": "exterior",
            "x1": 48,
            "x2": 48,
            "y1": 1,
            "y2": 40.5
        },
        {
            "id": "garage-south-left",
            "kind": "exterior",
            "x1": 1,
            "x2": 48,
            "y1": 40.5,
            "y2": 40.5
        },
        {
            "id": "garage-west",
            "kind": "exterior",
            "x1": 1,
            "x2": 1,
            "y1": 24.5,
            "y2": 40.5
        },
        {
            "id": "wall-1",
            "kind": "exterior",
            "x1": 1,
            "x2": 10,
            "y1": 24.5,
            "y2": 24.5
        },
        {
            "id": "wall-2",
            "kind": "exterior",
            "x1": 10,
            "x2": 10,
            "y1": 1,
            "y2": 24.5
        }
    ],
    "widthUnits": 49,
    "zones": [
        {
            "borderOpacity": 65,
            "borderStyle": "solid",
            "borderWidth": 0.125,
            "color": "#36c6b1",
            "fillOpacity": 9,
            "height": 15,
            "id": "basement-ops-console-1",
            "label": "OPS\nCONSOLE",
            "labelPosition": "center",
            "lineHeight": 1.2,
            "maxLines": 4,
            "maxWidth": 12,
            "width": 5.5,
            "wrapMode": "none",
            "x": 1.5,
            "y": 25
        },
        {
            "borderOpacity": 65,
            "borderStyle": "dashed",
            "borderWidth": 0.125,
            "color": "#d9aa2f",
            "fillOpacity": 9,
            "height": 6.5,
            "id": "basement-delivery-zone-1",
            "label": "DELIVERY ZONE",
            "labelPosition": "center",
            "lineHeight": 1.2,
            "maxLines": 4,
            "maxWidth": 12,
            "width": 10,
            "wrapMode": "none",
            "x": 37.5,
            "y": 1.5
        },
        {
            "borderOpacity": 65,
            "borderStyle": "dashed",
            "borderWidth": 0.125,
            "color": "#e95b55",
            "fillOpacity": 9,
            "height": 5.5,
            "id": "basement-sell-zone-1",
            "label": "SELL\nZONE",
            "labelPosition": "center",
            "lineHeight": 1.2,
            "maxLines": 4,
            "maxWidth": 12,
            "width": 5,
            "wrapMode": "word",
            "x": 10.5,
            "y": 12.5
        },
        {
            "borderOpacity": 65,
            "borderStyle": "solid",
            "borderWidth": 0.125,
            "color": "#85898f",
            "fillOpacity": 9,
            "height": 6.5,
            "id": "basement-staircase-1",
            "label": "STAIRCASE",
            "labelPosition": "center",
            "lineHeight": 1.2,
            "maxLines": 4,
            "maxWidth": 12,
            "width": 17,
            "wrapMode": "none",
            "x": 20,
            "y": 1.5
        }
    ]
}
